import { inject, Injectable } from '@angular/core';
import { DBSchema, openDB } from 'idb';
import { InvoiceScannerService } from '../invoiceScanner/invoice-scanner.service';



@Injectable({
  providedIn: 'root',

})
export class StorageService {

  private $invoiceScannerService: InvoiceScannerService = inject(InvoiceScannerService);

  private db = openDB<DBData>('StorageDB', 1, {
    upgrade(db) {
      db.createObjectStore('offline');
    },
  });


  constructor() {
    window.addEventListener('online', () => {
      this.$sendPendingData();
    });
  }


  private async $sendPendingData() {
    const pendingData = await this.getAllPendingData();

    for (const data of pendingData) {
      try {
        if (!data.isSynchronized) {
          data.isSynchronized = true;
          await this.saveOfflineData(data.key, data);
          this.$invoiceScannerService.sendForm(data.payload).subscribe({
            error: (err) => console.error('Error al reenviar formulario (sendForm):', err),
          });
        }
      } catch (err) {
        console.error('Error al reenviar formulario', err);
        return;
      }
    }
  }


  public async saveOfflineData(key: string, data: any) {
    const db = await this.db;
    await db.put('offline', data, key);
  }


  public async getAllPendingData(): Promise<any[]> {
    const db = await this.db;
    const keys = await db.getAllKeys('offline');

    return await Promise.all(keys.map((key: any) => db.get('offline', key)));
  }


  public async getLastData(): Promise<any> {
    const db = await this.db;
    const keys = await db.getAllKeys('offline');
    const last:  IDBKeyRange = keys.at(-1) as unknown as IDBKeyRange
    return await db.get('offline', last)
  }


  async clearPendingData() {
    const db = await this.db;
    await db.clear('offline');
  }
}



interface DBData extends DBSchema {
  'offline': {
    key: string;
    value: any;
  };
}
